let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5AlTx")).then(() => parcelRequire('3EgOL'));